import React from 'react';

function CheckIcon(props: object) {
  return (
    <svg
      width="29"
      height="20"
      viewBox="0 0 29 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3102 19.4388C9.97443 19.7449 9.4988 20 9.07911 20C8.65943 20 8.18379 19.7321 7.83406 19.426L0 12.2832L2.49011 10.0128L9.0931 16.0332L26.5519 0L29 2.30867L10.3102 19.4388Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CheckIcon;
